<div class="dashboard-container">
    <!-- <h1 class="dashboard-title">Reports Dashboard</h1> -->
    <div class="dashboard-cards">
        <mat-card class="dashboard-card" (click)="navigateToJobCardReport()">
            <mat-icon class="dashboard-icon">assignment</mat-icon>
            <h2>Job Card Report</h2>
            <p>Access detailed Job Card reports</p>
        </mat-card>

        <mat-card class="dashboard-card" (click)="navigateToComplaintReport()">
            <mat-icon class="dashboard-icon">report</mat-icon>
            <h2>Complaint Report</h2>
            <p>Access detailed complaint reports</p>
        </mat-card>

        <mat-card class="dashboard-card" (click)="navigateToComplaintsSummaryReport()">
            <mat-icon class="dashboard-icon">report</mat-icon>
            <h2>Complaints Summary Report</h2>
            <p>Access detailed complaints summary reports</p>
        </mat-card>

        <!-- <mat-card class="dashboard-card" (click)="navigateToJasperReports()">
            <mat-icon class="dashboard-icon">description</mat-icon>
            <h2>Jasper Reports</h2>
            <p>Generate and view Jasper reports</p>
        </mat-card> -->
    </div>
</div>
